
import { defineComponent, Component, PropType } from "vue";
import IconRoad from "~icons/tabler/road";
import IconEcology from "~icons/tabler/battery-eco";
import IconCategory from "~icons/tabler/category";
import IconShield from "~icons/tabler/shield-chevron";
import IconBusinessPlan from "~icons/tabler/businessplan";
import IconBulb from "~icons/tabler/bulb";
import IconVolumeOff from "~icons/tabler/volume-off";
import IconPoo from "~icons/tabler/poo";
import IconTrash from "~icons/tabler/trash";
import IconFilterDollar from "~icons/tabler/filter-dollar";
import IconTheater from "~icons/tabler/masks-theater";
import IconTrees from "~icons/tabler/trees";
import IconWoman from "~icons/tabler/woman";
import IconSpeakerphone from "~icons/tabler/speakerphone";
import IconDroplet from "~icons/tabler/droplet";
import IconSchool from "~icons/tabler/school";
import IconParking from "~icons/tabler/parking";
import IconGrave from "~icons/tabler/grave";
import IconTie from "~icons/tabler/tie";
import IconStethoscope from "~icons/tabler/stethoscope";
import IconYoga from "~icons/tabler/yoga";
import IconBuilding from "~icons/tabler/building";
import IconCameraPin from "~icons/tabler/camera-pin";
import IconBuildingCommunity from "~icons/tabler/building-community";
import IconKid from "~icons/tabler/mood-kid";
import IconMapSearch from "~icons/tabler/map-search";
import IconBuildingBank from "~icons/tabler/building-bank";

export default defineComponent({
  props: {
    type: {
      type: [String, null] as PropType<string | null>,
      required: true,
    },
  },
  components: {
    IconRoad,
    IconEcology,
    IconCategory,
    IconShield,
    IconBusinessPlan,
    IconBulb,
    IconVolumeOff,
    IconPoo,
    IconTrash,
    IconFilterDollar,
    IconTheater,
    IconTrees,
    IconWoman,
    IconSpeakerphone,
    IconDroplet,
    IconSchool,
    IconParking,
    IconGrave,
    IconTie,
    IconStethoscope,
    IconYoga,
    IconBuilding,
    IconCameraPin,
    IconBuildingCommunity,
    IconKid,
    IconMapSearch,
    IconBuildingBank,
  },
  data() {
    return {
      iconMapper: {
        roads: IconRoad,
        civil_protection: IconShield,
        ecology: IconEcology,
        investments: IconBusinessPlan,
        public_lighting: IconBulb,
        public_order: IconVolumeOff,
        sewerage_system: IconPoo,
        municipal_waste: IconTrash,
        municipal_fee: IconFilterDollar,
        culture: IconTheater,
        urban_green_spaces: IconTrees,
        youth: IconWoman,
        billboard_advertising: IconSpeakerphone,
        water_supply: IconDroplet,
        primary_schools: IconSchool,
        other: IconCategory,
        parking: IconParking,
        cemeteries: IconGrave,
        commercial_spaces: IconBuildingBank,
        protocol: IconTie,
        social_welfare_healthcare: IconStethoscope,
        sports: IconYoga,
        residential_units: IconBuilding,
        tourism: IconCameraPin,
        urbanism: IconBuildingCommunity,
        kindergartens: IconKid,
        land_parcels: IconMapSearch,
      },
    };
  },
  computed: {
    iconComponent() {
      if (!this.type) {
        return IconCategory;
      }

      return (
        (this.iconMapper as Record<string, Component>)[this.type] ||
        IconCategory
      );
    },
  },
});
